import { api } from '@/lib/api';

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

export const monthlySummaryApi = {
  downloadCsv: async (year: number, month: number) => {
    const res = await api.get('/admin/reporting/monthly-summary/download', {
      params: { year, month },
      responseType: 'blob',
    });
    saveBlob(res.data as Blob, `synthese-mensuelle-${year}-${String(month).padStart(2, '0')}.csv`);
  },
};
